<script lang="ts">
    import { setTypedContext } from "@lib/svelte-typed-context";
    import CN from "classnames";

    import { tabsNameContextToken } from "./constants";

    export let tabsName: string;
    let className: string | undefined = undefined;
    export { className as class };
    setTypedContext(tabsNameContextToken, tabsName);
</script>

<div class={CN("gw-tabs", className)}>
    <div class="gw-tabs__header">
        <slot name="menu" />
    </div>
    <div class="gw-tabs__body">
        <slot name="body" />
    </div>
</div>

<style>
    .gw-tabs {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }
    .gw-tabs__body {
        flex-grow: 1;
        width: 100%;
        position: relative;
    }
</style>
